import {Component,OnInit,ElementRef,ViewChild, Renderer2} from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import {CallClient,VideoStreamRenderer,LocalVideoStream,Features,VideoStreamRendererView,DominantSpeakersInfo} from '@azure/communication-calling';
import { AzureCommunicationTokenCredential } from '@azure/communication-common';
import { LoaderService } from 'src/app/service/loader.service';
import { ChatClient } from '@azure/communication-chat';
import { RestService } from 'src/app/service/rest.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { AlertComponent } from '../../message/alert/alert.component';
import { BehaviorSubject } from 'rxjs';
import { MeetingEventType } from '../../../core/enums/meeting-event-type.enum';
import { environment } from 'src/environments/environment';
import { ApiUrls } from 'src/app/core/apiUrls';
import { MeetingErrorType } from 'src/app/core/enums/error-type';
import { callEndedType } from 'src/app/core/enums/call-ending-type';
import * as CryptoJS from 'crypto-js';
import { CookieService } from 'ngx-cookie-service';

let previewScreenCamObj: VideoStreamRendererView;

@Component({
    selector: 'app-video-call',
    templateUrl: './video-call.component.html',
    styleUrls: ['./video-call.component.scss'],
    standalone: false
})
export class VideoCallComponent implements OnInit {
  @ViewChild('commentsCheckbox') commentsCheckbox!: ElementRef;
  @ViewChild('ideasCheckbox') ideasCheckbox!: ElementRef;
  @ViewChild('challengesCheckbox') challengesCheckbox!: ElementRef;
  @ViewChild('videoContainer', {static: false })container!:ElementRef;
  @ViewChild('chatContainer') chatContainer!: ElementRef;
  @ViewChild('chatContainerMob') chatContainerMob!: ElementRef;
  @ViewChild('snackbar') userLeftToast! : ElementRef

  meetingEventType: any = MeetingEventType;
  constructor(
    private fb: FormBuilder,
    private rest: RestService,
    private loader: LoaderService,
    private router: Router,
    private activateRoute: ActivatedRoute,
    private dialog: MatDialog,
    private renderer: Renderer2,
    private cookieService : CookieService,
  ) {}

  teamsCallAgent: any;
  deviceManager: any;
  call: any;
  incomingCall: any;
  localVideoStreamUser: any;
  localVideoStreamScreenShare: any;
  localVideoStreamRenderer: any;
  localScreenShareStreamRenderer: any;
  userAccessToken: any;
  calleeTeamsUserId: any;
  initializeCallAgentButton: boolean = true;
  startCallButton: any;
  startGroupCallButton: any;
  hangUpCallButton: any;
  acceptCallButton: any;
  startVideoButton: any;
  stopVideoButton: any;
  connectedLabel: any;
  remoteVideoContainer: any;
  localVideoContainer: any;
  localVideoContainerStreaming: any;
  joinChatMsgButton: any;
  sendChatMsgButton: any;
  roomId: any;
  groupId: any;
  chatId: any;
  chatText: any;
  chatUserName: any;
  chatClient: any;
  chatThreadClient: any;
  endpointUrl = environment.acsEndPointUrl;
  tokenCredential: any;
  startScreenShareButton: any;
  stopScreenShareButton: any;
  screenShareStream: any;
  videoForm!: FormGroup;
  chatMessages: any;
  muteButton: any;
  unMuteButton: any;
  userConnectedToCall: boolean = false;
  groupCallIdAPI: any;
  meetingDetails: any;
  meetingTitle: any;
  showVideoWindow: any = 'PermissionScreen';
  recordMeetingServerCallID: any;
  userDetails: any;
  localUserName: any;
  userIdAPI: any;
  userTokenAPI: any;
  participantCount: any;
  meetingStartTime: any;
  meetingEndTime: any;
  meetingDescription: any;
  previewVideoView: any;
  videoPlaceholder: any;
  videoPlaceholderName: any;
  isMeeting: any;
  isMeetingInformation: any;
  previewVideoOnOff: boolean = false;
  previewMuteOnOff: boolean = false;
  isPreviewMicStatus: boolean = false;
  isPreviewVideoStatus: boolean = false;
  totalNumberOfParticipants: BehaviorSubject<number> =
    new BehaviorSubject<number>(0);
  lastUpdated: BehaviorSubject<number> = new BehaviorSubject<number>(
    new Date().getTime()
  ); // time in millisecond
  localUserNameInitials: any;
  speakerName: any;
  adminUserId: any;
  isAdmin: boolean = false;
  showUsersList: boolean = false;
  showUserInitialLocal: boolean = true;
  isScreenShared : boolean = false;
  userCountAfterNine : any = 0;
  userCountAfterNineBoolean : boolean = false;
  totalNumberOfParticipantsCount : any;
  isAdminIdFromApi : any;
  isAudioControlEnabled :  boolean = false;
  isChatEnabled: boolean = false;
  isScreenShareEnabled: boolean = false;
  isUserControlEnabled: boolean = false;
  isVideoControlEnabled: boolean = false;
  remoteParticipantsState : any[] = [];
  localScreenShareStream : any;
  isLocalScreenShared : boolean = false;
  remoteScreenShareStream : any;
  isRemoteScreenShared : boolean = false;
  fileType:any;
  selectedFile!: File;
  showMessageBox: boolean = false;
  higherScreenRes: boolean = true;
  higherScreenResUser: boolean = true;
  showUserList: boolean = false;
  messageUserBox: boolean = false;
  previewVideoStream: any;
  videoPlaceholderNameHidden:any;
  videoPlaceholderHidden:any;
  isCameraOn : boolean = false;
  screenShareStarted: boolean = false;
  localVideo : any;
  localVideoOn : boolean = false;
  isCameraPermitted : boolean = false;
  isMicroPhonePermitted : boolean = false;
  cameraPermissionDenied = false;
  microphonePermissionDenied = false;
  showRejectionMessage : boolean = false;
  chatMessageCounter : any = [];
  userLeftMessage : any = {};
  screenStream : any;
  isUserAlreadyExists : boolean = false;
  callSecondReference : any;
  isFileUploaded : boolean = false;
  isFileUploading : boolean = false;
  userLeftMessageSnackBar : any;
  isEndMeetingButtonClicked : boolean = false;
  isAdminJoined : boolean = false;
  getMeetingApiCallForisAdminJoined : any;
  isLocalUserCameraTurnedOn : boolean = false;
  isLocalUserMicTurnedOn : boolean = false;
  reRouteMessage : any;
  showReRouteMessage : boolean = false;
  isTokenFromUrl : boolean = false;
  tokenFromUrl : any;
  accessCode :any;
  redirectUrl : any = environment.afriSureUat + '?redirect_url=' + window.location.href

  ngOnInit(): void {
    this.activateRoute.params.subscribe((orgId) => {
      this.groupCallIdAPI = orgId['id'];
      // this.accessCode = orgId['acId'];
      // this.accessCode=orgId['auth'];
     
    });
    this.activateRoute.queryParams.subscribe(params =>{   
        this.accessCode= params['auth'];
        console.log(this.accessCode,'accessCode');
        
        // alert(this.accessCode)
 
       
    })
    this.activateRoute.fragment.subscribe((fragment) => {
      this.tokenFromUrl = fragment;
      if (this.tokenFromUrl?.includes('token=')) {
        this.isTokenFromUrl =true;
        let tokenUrlSplit : any  = this.tokenFromUrl?.split('token=')[1];
        localStorage.clear();
        localStorage.setItem('ACS-Token',tokenUrlSplit);
        this.isTokenFromUrl =true;
        this.router.navigate(['meeting',this.groupCallIdAPI]);
      }
    

      else {
        this.isTokenFromUrl =false;
      }


    });


    // this.activateRoute.queryParamMap.subscribe(params =>
    // {       
    //     this.accessCode = params.get('domainId');       
    //     console.log(this.accessCode); 
    // });
    let ACSToken:any=  localStorage.getItem('ACS-Token')
    if(this.accessCode){
      this.getCode();
    } else if((ACSToken!=undefined || ACSToken!=null)&&this.groupCallIdAPI){
      this.checkAndRequestCameraPermission();
    }
    else{
    
      if(this.isTokenFromUrl){
          // mobile flow 
        this.checkAndRequestCameraPermission();
      }else{
        this.getDomainDetails();
      }
    }

    this.videoForm = this.fb.group({
      token: ['', [Validators.required]],
      userId: [''],
      roomId: [''],
      groupId: [''],
      chatThreadId: [''],
      userChatName: [''],
      userChatTest: [''],
    });

    

  }

  ngAfterViewInit(): void {

  }

  async getCamAccessFromUser(){
    const callClient = new CallClient();
    this.deviceManager = await callClient.getDeviceManager();
    this.loader.show();
    await this.deviceManager.askDevicePermission({ video: true }).then((res: any) => {
      // console.log('video promise returns', res.video);
      this.isCameraPermitted = res.video;
      this.loader.hide();
    });
 
    if(!this.isCameraPermitted){}
  }
  async getMicAccessFromUser(){
    const callClient = new CallClient();
    this.deviceManager = await callClient.getDeviceManager();
    this.loader.show();
    await this.deviceManager.askDevicePermission({ audio: true }).then((res: any) => {
      // console.log('audio promise returns', res.audio);
      this.isMicroPhonePermitted = res.audio;
      this.loader.hide();
    });
 
    if(!this.isMicroPhonePermitted){}
  }

  proccedToPreviewScreen(){
    if(this.isMicroPhonePermitted && this.isCameraPermitted){
      this.showVideoWindow='PreviewVideoScreen';
      this.getMeeting();
    }
    else if(!this.isMicroPhonePermitted && !this.isCameraPermitted){
      let popupData : any = MeetingErrorType.bugNoAccessToCamAndMic;
      this.showErrorWarning(popupData);
    }
    else if(!this.isMicroPhonePermitted || this.isCameraPermitted){
      let popupData : any = MeetingErrorType.bugNoAccessToMic;
      this.showErrorWarning(popupData);
    }else if(!this.isCameraPermitted || this.isMicroPhonePermitted){
      let popupData : any = MeetingErrorType.bugNoAccessToCam;
      this.showErrorWarning(popupData);
    }
    else{
      this.showRejectionMessage = true;
    }
  }

  get a() {
    return this.videoForm.controls;
  }

  getDomainDetails(){

    let inputReq: any = {
      // "requestedPageURL": '/meeting/'+this.groupCallIdAPI,
      // "requestedDomain" : '/meeting/'+this.groupCallIdAPI,
      "requestedPageURL": window.location.href,
      "requestedDomain" : window.location.href,
    };
    this.loader.show();
    this.rest.getDomainDetails(inputReq,ApiUrls.getDomainDetails,null,'LoginUrl').subscribe((data: any) => {
      if (data.rcode == 200) {
        this.loader.hide();
        window.open(data.rObj.redirectURL, '_self');  
      }else{
        this.loader.hide();
      }
    },
    (err: any) => {
      console.error(err);
      this.loader.hide();
    }
  );
  }

  getCode() {
   this.loader.show();
    let params = {
      accessCode: this.accessCode,
    };
    this.rest.getDomainDetails(params, ApiUrls.GetTokenByAccessCode).subscribe(
        (data) => {
          if (data.rcode == 200) {
            this.loader.hide();
            localStorage.setItem('ACS-Token',data.rObj.token);
            // console.log(data,'GetTokenByAccessCode');
           let redirectUrl=data.rObj.redirectURL
            if(redirectUrl){
              window.open(redirectUrl, '_self');
              // this.checkAndRequestCameraPermission();
            }
            else{
                this.reRouteMessage= 'Meeting ID not found';
                this.showVideoWindow = 'showReRouteMessage';
                window.open(this.redirectUrl, '_self');
            }
            this.loader.hide();
          } else {
            alert('unauthorized');
          }
        },
        (error) => {}
      );
  }

  getMeeting() {

    this.loader.show();
    let inputReq: any = {};
    inputReq.groupCallId = this.groupCallIdAPI;
    this.rest.acsMFEPostData(inputReq,ApiUrls.getMeeting,null,'LoginUrl').subscribe((data: any) => {
          if (data.rcode == 200) {
            let responseData: any = data.rObj.MeetingDetails;
            this.meetingDetails = responseData;
            this.isUserAlreadyExists = data.rObj.IsUserAlreadyExists;
            if(this.isUserAlreadyExists){
              this.loader.hide();
              this.router.navigate(['/call-ended',callEndedType.userAlreadyInMeeting.callId]);
            }
            this.meetingTitle = this.meetingDetails.title;
            this.meetingStartTime = this.meetingDetails.startTime;
            this.meetingEndTime = this.meetingDetails.startTime;
            this.meetingDescription = this.meetingDetails.description;
            this.speakerName = this.meetingDetails.speakerName;
            this.videoForm.patchValue({
              chatThreadId: this.meetingDetails.meetingChatID,
              groupId: this.groupCallIdAPI,
            });
            this.adminUserId = this.meetingDetails.createdBy;
            this.createUser(this.adminUserId,this.groupCallIdAPI,this.meetingDetails.meetingChatID);
            // console.log('search for form value here : \n',this.videoForm.value);
            
            this.loader.hide();
            this.getMeetingApiCallForisAdminJoined = setInterval(() => {
              this.checkWheterAdminJoinedByGetMeeting(inputReq,ApiUrls.getMeeting,null,'LoginUrl');
            }, 10000);
          } else if (data.rcode == 401) {
            // this.router.navigate(['login']);
            this.getDomainDetails();
          } else if (data.rcode == 501) {
            this.loader.hide();
            this.getDomainDetails();
          }else if (data.rcode == 500) {
            this.loader.hide();
            this.getDomainDetails();
          } else if (data.rmsg && data.rmsg[0]?.errorCode == 'ERR018') {
            this.loader.hide();
            const dialogRef = this.dialog.open(AlertComponent, {
              width: '35vw',
              data: {
                data: 'We encountered a server issue. We will refresh the page for you to try again.',
                type: 'alert',
              },
            });
            dialogRef.afterClosed().subscribe((result) => {
              window.location.reload();
            });
          } else {
            this.loader.hide();
          }
        },
        (err: any) => {
          this.loader.hide();
          // this.router.navigate(['/start-meeting']);
          this.getDomainDetails();
          
        }
      );
  }

  checkWheterAdminJoinedByGetMeeting(inputReq : any,getMeetingAPIUrl : any,flag :any,urlType : any){
    this.rest.acsMFEPostData(inputReq,getMeetingAPIUrl,flag,urlType).subscribe((data: any) => {
      let responseData = data.rObj;
      this.isAdminJoined = responseData.IsAdminJoined;
      if(this.isAdminJoined){
        clearInterval(this.getMeetingApiCallForisAdminJoined);
      }
    })
  }

  createUser(adminUserId : any,grpCallId:any,chatId : any) {
    this.loader.show();
    let inputReq: any = {};
    inputReq.groupCallGuid = grpCallId;
    inputReq.createdBy = adminUserId;
    // inputReq.groupServerCallId = this.recordMeetingServerCallID;
    this.rest.acsMFEPostData(inputReq,ApiUrls.createUser,null,'LoginUrl').subscribe(
        (data: any) => {
          if (data.rcode == 200) {
            let responseData: any = data.rObj.UserDetails;
            this.userIdAPI = responseData.userId;
            this.userTokenAPI = responseData.token;
            this.isAdminIdFromApi = data.rObj.LoggedInUserID;
            this.isAudioControlEnabled = responseData.isAudioControlEnabled;
            this.isVideoControlEnabled = responseData.isVideoControlEnabled;
            this.isScreenShareEnabled = responseData.isScreenShareEnabled;
            this.isChatEnabled = responseData.isChatEnabled;
            this.isUserControlEnabled = responseData.isUserControlEnabled;
            this.videoForm.patchValue({
              token: this.userTokenAPI,
              userId: this.userIdAPI,
            });
            if (this.adminUserId === this.isAdminIdFromApi) {
              this.isAdmin = true;
              clearInterval(this.getMeetingApiCallForisAdminJoined);
              this.isAdminJoined = true;
            } else {
              this.isAdmin = false;
            }
            this.calleeTeamsUserId = this.userIdAPI;
            this.localUserName = responseData.username;
            this.localUserNameInitials = this.createUserInitials(this.localUserName);
            // console.log('search for form value here : \n',this.videoForm.value);
            if(this.isChatEnabled){
            this.addUsersToChatThread(this.userIdAPI,responseData.username,chatId);
            }
            if(this.isVideoControlEnabled){
            this.initializeCameraPreview();
            }else{
              this.isPreviewVideoStatus = false;
              this.videoPlaceholderHidden = true;
              this.videoPlaceholderNameHidden = true;
              this.showUserInitialLocal = false;
            }
            this.loader.hide();
          } else if (data.rcode == 401) {
            // this.router.navigate(['login']);
            this.getDomainDetails();
          } else if (data.rcode == 500) {
            this.loader.hide();
            this.getDomainDetails();
          } else if (data.rcode == 501) {
            this.loader.hide();
          } else if (data.rmsg && data.rmsg[0]?.errorCode == 'ERR018') {
            this.loader.hide();
            const dialogRef = this.dialog.open(AlertComponent, {
              width: '35vw',
              data: {
                data: 'We encountered a server issue. We will refresh the page for you to try again.',
                type: 'alert',
              },
            });
            dialogRef.afterClosed().subscribe((result) => {
              window.location.reload();
            });
          } else {
            this.loader.hide();
          }
        },
        (err: any) => {
          this.loader.hide();
          // this.router.navigate(['/start-meeting']);
          this.getDomainDetails();
        }
      );
  }

  addUsersToChatThread(userId : any,userName : any,chatThreadId: any) {

    let inputReq: any = {};
    inputReq.acsUserId = userId;
    inputReq.acsusername = userName;
    inputReq.chatThreadId = chatThreadId;
    this.rest.acsMFEPostData(inputReq,ApiUrls.addUsersToChatThread,null,'LoginUrl').subscribe(
        (data: any) => {
          if (data.rcode == 200) {
            let responseData: any = data;
            // console.log('User added to the chat thread');

          } else if (data.rcode == 401) {
            // this.router.navigate(['login']);
            this.getDomainDetails();
          } else if (data.rcode == 501) {

          }else if (data.rcode == 500) {
            this.getDomainDetails();
          } else if (data.rmsg && data.rmsg[0]?.errorCode == 'ERR018') {
            this.loader.hide();
            const dialogRef = this.dialog.open(AlertComponent, {
              width: '35vw',
              data: {
                data: 'We encountered a server issue. We will refresh the page for you to try again.',
                type: 'alert',
              },
            });
            dialogRef.afterClosed().subscribe((result) => {
              window.location.reload();
            });
          } else {

          }
        },
        (err: any) => {
          this.loader.hide();
          // this.router.navigate(['/start-meeting']);
          this.getDomainDetails();
        }
      );
  }

  createUserInitials(username: any) {
    var inputString = username;
    var words = inputString.split(' ');
    var firstLetterFirstWord = words[0].charAt(0);
    var lastWordIndex = words.length - 1;
    var firstLetterLastWord = words[lastWordIndex].charAt(0);
    return firstLetterFirstWord.toUpperCase() + ' ' + firstLetterLastWord.toUpperCase();
  }

  async initializeCameraPreview() {
    try{
    this.isPreviewVideoStatus = true;
    const callClient = new CallClient();
    this.deviceManager = await callClient.getDeviceManager();
    await this.deviceManager.askDevicePermission({ video: true });
    await this.deviceManager.askDevicePermission({ audio: true });

    const cameras = await this.deviceManager.getCameras();
    const camera = cameras[0];
    const localVideoStream = new LocalVideoStream(camera);
    const videoStreamRenderer = new VideoStreamRenderer(localVideoStream);
    const view = await videoStreamRenderer.createView();
    var divElement = view.target;

    var videoElement: any = divElement.querySelector('video');
    videoElement.style.objectFit = '';
    videoElement.classList.add('previewScreenVideo');
    var marqueSpan = document.createElement('span');
    divElement.appendChild(marqueSpan);
    var marqueeMark = document.createElement('mark');
    var marqueeElement = document.createElement('marquee');

    marqueSpan.classList.add('cameraPreviewMarqueContainer');

    marqueeElement.classList.add('marqueeBorder');
    marqueeMark.textContent = this.localUserName;
    marqueeElement.setAttribute('direction', 'left');
    marqueeElement.setAttribute('behavior', 'scroll');
    marqueeElement.appendChild(marqueeMark);
    marqueSpan.appendChild(marqueeElement);

    previewScreenCamObj = view;

    this.videoPlaceholderHidden = false;

    this.videoPlaceholderNameHidden = false;
    this.showUserInitialLocal = true;
    if(divElement){
      this.isCameraOn=true;
      this.previewVideoStream = view.target;
    }else{
      this.isCameraOn=false;
    }
    this.isLocalUserCameraTurnedOn = true;
    this.previewVideoOnOff = false;
    }catch(err){
      this.videoPlaceholderHidden = true;
      this.videoPlaceholderNameHidden = true;
      this.isCameraOn = false;
      this.previewVideoOnOff = true;
      console.error(err);
      let popupData : any = MeetingErrorType.bugPreviewScreenTurnOnCamera;
      this.showErrorWarning(popupData);
    }
  }

  stopVideoPreviewButtonClick = async () => {
    try{
    this.isPreviewVideoStatus = false;
    previewScreenCamObj.dispose();

    this.videoPlaceholderHidden = true;

    this.videoPlaceholderNameHidden = true;
    this.showUserInitialLocal = false;
    this.isCameraOn = false;
    this.isLocalUserCameraTurnedOn = false;
    this.previewVideoOnOff = true;
  }catch(err){
    this.previewVideoOnOff = false;
    console.error(err)
    let popupData : any = MeetingErrorType.bugPreviewScreenTurnOffCamera;
    this.showErrorWarning(popupData);
  }
  };

  previewMute() {
    this.isPreviewMicStatus = false;
  }
  previewUnmute() {
    this.isPreviewMicStatus = true;
  }

  async initializeCallAgentButtonClick(): Promise<void> {
    if (this.adminUserId === this.isAdminIdFromApi) {
      this.isAdmin = true;
      this.rest.LogMeetingHistory(this.videoForm.value,this.meetingEventType.MeetingStarted,'Meeting Started',false);
    } else {
      this.isAdmin = false;
    }
    if(this.isPreviewVideoStatus){
      previewScreenCamObj.dispose();
    }
    try {
      this.loader.show();
      const callClient = new CallClient();
      this.tokenCredential = new AzureCommunicationTokenCredential(
        this.videoForm.value.token.trim()
      );

      const callAgentOptions = { displayName: this.localUserName || 'User' };
      this.teamsCallAgent = await callClient.createCallAgent(
        this.tokenCredential,
        callAgentOptions
      );

      // boolean to show screen
      this.userConnectedToCall = true;
      this.showVideoWindow = 'VideoScreen';
      // Listen for an incoming call to accept.
      this.teamsCallAgent.on('incomingCall', async (args: any) => {
        try {
          this.incomingCall = args.incomingCall;


        } catch (error) {
          this.rest.logUserLeftAndReloadScreen(this.videoForm.value,this.meetingEventType.UserLeft,'User Left',false);
          console.error(error);
        }
      });
      this.teamsCallAgent.on(
        'callsUpdated',
        (e: { added: any[]; removed: any[] }): void => {
          e.added.forEach((addedCall) => {
            addedCall.on('stateChanged', (): void => {
              if (addedCall.state === 'Connected') {
                // addedCall.info
                //   .getServerCallId()
                //   .then((result: any) => {
                //     console.log('Server Call ID: ', result);
                //     this.recordMeetingServerCallID = result;
                //   })
                //   .catch((err: any) => {
                //     // console.log(err);
                //     this.rest.logUserLeftAndReloadScreen(this.videoForm.value,this.meetingEventType.UserLeft,'User Left',false);
                //   });
              }
            });
          });
        }
      );

      this.initializeCallAgentButton = false;

      this.loader.hide();
      this.joinGroupCallButtonClick();
    } catch (error) {
      console.error(error);
      this.rest.logUserLeftAndReloadScreen(this.videoForm.value,this.meetingEventType.UserLeft,'User Left',false);
    }
  }
  
  async joinGroupCallButtonClick(): Promise<void> {
    try {
      if(this.isVideoControlEnabled){
      const localVideoStream = await this.createLocalVideoStream();
      const videoOptions = localVideoStream
        ? { localVideoStreams: [localVideoStream] }
        : undefined;
      }
      const context = { groupId: this.videoForm.value.groupId.trim() };

      this.call = this.teamsCallAgent.join(context);
      this.callSecondReference = this.call
      // Subscribe to the call's properties and events.
      this.subscribeToCall(this.call);
    } catch (error) {
      console.error(error);
      this.rest.logUserLeftAndReloadScreen(this.videoForm.value,this.meetingEventType.UserLeft,'User Left',false);
    }
  }

  subscribeToCall = (call: any) => {
    try {
      // Inspect the initial call.id value.
      // console.log(`Call Id: ${call.id}`);
      //Subsribe to call's 'idChanged' event for value changes.
      call.on('idChanged', () => {
        // console.log(`Call ID changed: ${call.id}`);
      });
      // Inspect the initial call.state value.
      // console.log(`Call state: ${call.state}`);
      // Subscribe to call's 'stateChanged' event for value changes.
      call.on('stateChanged', async () => {
        // console.log(`Call state changed: ${call.state}`);
        if (call.state === 'Connected') {
          this.rest.LogMeetingHistory(this.videoForm.value,this.meetingEventType.Userjoined,'User Joined',false);
          // call.info.getServerCallId().then((result: any) => {
          //     // console.log('Server Call ID: ', result);
          //     this.recordMeetingServerCallID = result;
          //   }).catch((err: any) => {
          //     this.rest.logUserLeftAndReloadScreen(this.videoForm.value,this.meetingEventType.UserLeft,'User Left',false);
          //     // console.log(err);
          //   });
          


          this.userConnectedToCall = true;

          if(this.isVideoControlEnabled){
            this.startVideoButton = true;
          }
          if (this.isScreenShareEnabled) {
            this.startScreenShareButton=true;
          } else {
            this.startScreenShareButton=false;
          }
          if(this.isChatEnabled){
          this.joinChatButtonClick();
          }
          if(this.isAudioControlEnabled){
            if (this.isPreviewMicStatus) {
              call.mute();
              this.muteButton= false;
              this.unMuteButton= true;
              this.rest.LogMeetingHistory(this.videoForm.value,this.meetingEventType.Mute,'audio turned off',false);
              this.isLocalUserMicTurnedOn = false;
            } else {
              call.unmute();
              this.muteButton= true;
              this.unMuteButton= false;
              this.rest.LogMeetingHistory(this.videoForm.value,this.meetingEventType.Unmute,'audio turned on',false);
              this.isLocalUserMicTurnedOn = true;
            }
          }else{
            call.mute();
            this.muteButton= false;
            this.unMuteButton= false;
            this.rest.LogMeetingHistory(this.videoForm.value,this.meetingEventType.Mute,'Audio configuration Turned Off',false);
          }
          if(this.isVideoControlEnabled){
          if (this.isPreviewVideoStatus) {
            this.startVideoButtonClick();
          } else {
            this.showUserInitialLocal = true;
          }
          }else{
            this.showUserInitialLocal = true;

            this.stopVideoButton = false;

            this.startVideoButton = false;
            this.rest.LogMeetingHistory(this.videoForm.value,this.meetingEventType.TurnOnCamera,'Video configuration Turned Off',false);
          }
          this.updateUserSpeakerState();
        } else if (call.state === 'Disconnected') {

          this.startVideoButton = false;

          this.startScreenShareButton=false;

          this.stopVideoButton = false;

          this.muteButton= false;

          this.userConnectedToCall == true;

          if(call.callEndReason.code == 400){
            this.rest.LogMeetingHistory(this.videoForm.value,this.meetingEventType.CallError,'Call Error',false);
          }
          if(call.callEndReason.code == 0 && call.callEndReason.subCode == 5300){
            this.router.navigate(['/call-ended',callEndedType.meetingEnded.callId]);
          }
        }
      });
      call.localVideoStreams.forEach(async (lvs: any) => {
        // console.log(lvs);
        await this.displayLocalVideoStream(lvs);
      });
      call.on('localVideoStreamsUpdated', (e: any) => {
        e.added.forEach(async (lvs: any) => {
          await this.displayLocalVideoStream(lvs);
          let lvsScreenShare = call.localVideoStreams.find( (stream : any) => { return stream.mediaStreamType === 'ScreenSharing' });
          let lvsUser = call.localVideoStreams.find( (stream : any) => { return stream.mediaStreamType === 'Video' });
          if(lvs._mediaStreamType ==="RawMedia" && lvs._mediaStreamSource.active){
            this.isLocalScreenShared = true;
            this.isScreenShared = true;
          }
          if(lvsUser){
            this.localVideoStreamUser = lvsUser;
          }
          if(lvsScreenShare){
            this.localVideoStreamScreenShare = lvsScreenShare;
          }
        });
        e.removed.forEach((lvs: any) => {
          this.removeLocalVideoStream(lvs);
        });
      });

      // Subscribe to screen share event
      call.on('isScreenSharingOnChanged', () => {
        if (!call.isScreenSharingOn) {

          this.startScreenShareButton=true;
          this.isScreenShared = false;

          this.stopScreenShareButton = false;
          this.rest.LogMeetingHistory(this.videoForm.value,this.meetingEventType.ScreenshareEnd,'Screen share stopped',false);
        } else {

          this.startScreenShareButton=false;
          this.isScreenShared = true;

          this.stopScreenShareButton = true;
        }
      });
      // Inspect the call's current remote participants and subscribe to them.
      call.remoteParticipants.forEach((remoteParticipant: any) => {
        this.subscribeToRemoteParticipantState(remoteParticipant)
      });
      // Subscribe to the call's 'remoteParticipantsUpdated' event to be
      // notified when new participants are added to the call or removed from the call.
      call.on('remoteParticipantsUpdated', (e: any) => {
        // Subscribe to new remote participants that are added to the call.
        e.added.forEach( async (remoteParticipant: any) => {
          let remoteParticipantObj : any = {
            speakerRank : 10001
          };
          remoteParticipantObj.remoteParticipant = remoteParticipant
          this.remoteParticipantsState.push(remoteParticipantObj);
          // console.log(this.remoteParticipantsState);

          this.subscribeToRemoteParticipantState(remoteParticipant)
        });
        // Unsubscribe from participants that are removed from the call
        e.removed.forEach((remoteParticipant: any) => {
          // console.log('Participant dropped', remoteParticipant._displayName);
          // console.log('Remote participant removed from the call.');
          // remove user here to object
          this.remoteParticipantsState = this.remoteParticipantsState.filter(obj => obj.remoteParticipant._identifier.communicationUserId !== remoteParticipant._identifier.communicationUserId);
          this.userLeftMessage.isUserLeft = true;
          this.userLeftMessage.userLeftMessage = remoteParticipant._displayName +' '+'has left the meeting';
          this.showSnackbar(this.userLeftMessage.userLeftMessage);
          // console.log(this.remoteParticipantsState)
       
        });
        this.totalNumberOfParticipants.next(call.remoteParticipants.length);
        // console.log( 'No of remote participants :', this.totalNumberOfParticipants.getValue());
        this.totalNumberOfParticipantsCount = this.totalNumberOfParticipants.getValue();
        if(this.totalNumberOfParticipantsCount>9){
          this.userCountAfterNine = this.totalNumberOfParticipantsCount;
          this.userCountAfterNineBoolean = true
        }else if(this.totalNumberOfParticipantsCount<9){
          this.userCountAfterNine = 0;
          this.userCountAfterNineBoolean = false
        }
      });

      call.on('isMutedChanged', () => {
        if (call.isMuted) {
           this.muteButton = false;
           this.unMuteButton = true;
        } else {
           this.muteButton = true;
           this.unMuteButton = false;
        }
     });
      const callDominantSpeakersApi = call.feature(Features.DominantSpeakers);
      let dominantSpeakers: DominantSpeakersInfo = callDominantSpeakersApi.dominantSpeakers;
      const dominantSpeakersChangedHandler = () => {
        // Get the most up to date list of dominant speakers
        let dominantSpeakers = callDominantSpeakersApi.dominantSpeakers;
        // console.log('dominantSpeakers.speakersList',dominantSpeakers.speakersList)
        this.assignRemoteParticipantsSpeakerRank(dominantSpeakers.speakersList);
      };
      callDominantSpeakersApi.on('dominantSpeakersChanged', dominantSpeakersChangedHandler);

    } catch (error) {
      this.rest.logUserLeftAndReloadScreen(this.videoForm.value,this.meetingEventType.UserLeft,'User Left',false);
      console.error(error);
    }
  };

  assignRemoteParticipantsSpeakerRank(dominantSpeakers : any){
    for (let remoteParticipantIndexNumber = 0; remoteParticipantIndexNumber < this.remoteParticipantsState.length; remoteParticipantIndexNumber++) {
      for (let dominantSpeakerIndexNumber = 0; dominantSpeakerIndexNumber < dominantSpeakers.length; dominantSpeakerIndexNumber++) {
        if (this.remoteParticipantsState[remoteParticipantIndexNumber].remoteParticipant._identifier.communicationUserId == dominantSpeakers[dominantSpeakerIndexNumber].communicationUserId) {
          this.remoteParticipantsState[remoteParticipantIndexNumber].speakerRank = dominantSpeakerIndexNumber;
          // console.log('speaker : ', this.remoteParticipantsState[remoteParticipantIndexNumber].remoteParticipant.displayName)
        }else{
          this.remoteParticipantsState[remoteParticipantIndexNumber].speakerRank = dominantSpeakers.length+1;
        }
      }
    }
    this.remoteParticipantsState.sort((a, b) => a.speakerRank - b.speakerRank);
    // console.log('array got sorted')
    // console.log(this.remoteParticipantsState);
  }

  subscribeToRemoteParticipantState = (remoteParticipant: any) => {
    try {
      // Inspect the initial remoteParticipant.state value.
      // console.log(`Remote participant state: ${remoteParticipant.state}`);
      // Subscribe to remoteParticipant's 'stateChanged' event for value changes.
      remoteParticipant.on('stateChanged', () => {
        // console.log(`Remote participant state changed: ${remoteParticipant.state}`);
      });
      // Inspect the remoteParticipants's current videoStreams and subscribe to them.
      remoteParticipant.videoStreams.forEach((remoteVideoStream: any) => {
        this.subscribeToRemoteVideoStreamState(remoteVideoStream,remoteParticipant);
      });
      // Subscribe to the remoteParticipant's 'videoStreamsUpdated' event to be
      // notified when the remoteParticiapant adds new videoStreams and removes video streams.
      remoteParticipant.on('videoStreamsUpdated', (e: any) => {
        // Subscribe to newly added remote participant's video streams.
        e.added.forEach((remoteVideoStream: any) => {
          this.subscribeToRemoteVideoStreamState(remoteVideoStream,remoteParticipant);
        });
        // Unsubscribe from newly removed remote participants' video streams.
        e.removed.forEach((remoteVideoStream: any) => {
          // console.log('Remote participant video stream was removed.');
        });
      });
      remoteParticipant.on('isMutedChanged', () => {
        if (remoteParticipant.isMuted) {} 
        else {}
      });
    } catch (error) {
      this.rest.logUserLeftAndReloadScreen(this.videoForm.value,this.meetingEventType.UserLeft,'User Left',false);
      console.error(error);
    }
  };

  subscribeToRemoteVideoStreamState = async (remoteVideoStream: any,remoteParticipant:any) => {
    // Create a video stream renderer for the remote video stream.
    
    var remoteParticipantObj : any ={};
    remoteParticipantObj.remoteParticipant = remoteParticipant;

    let videoStreamRenderer = new VideoStreamRenderer(remoteVideoStream);
    let view: any;

    const renderVideo = async () => {
      try {

        if(remoteVideoStream._mediaStreamType === "ScreenSharing" && (remoteVideoStream.isAvailable && remoteVideoStream._isAvailable)){
          this.isScreenShared = true;
          this.isRemoteScreenShared = true;
          // console.log('screen sharing is enabled by remote user');
        }

        // Create a renderer view for the remote video stream.
        view = await videoStreamRenderer.createView();
        var videoType: any = view.videoStream._mediaStreamType;
        switch (videoType) {
          case "Video":
            var divElement = view.target;

            remoteParticipantObj.videoRendererDiv = divElement;
            break;
          case "ScreenSharing":
            var divElement = view.target;

            this.isRemoteScreenShared = true;
            this.isScreenShared = true;
            this.remoteScreenShareStream = divElement;
            break;
          // No default case
        }
        this.lastUpdated.next(new Date().getTime());

        this.remoteParticipantsState = this.remoteParticipantsState.filter(obj => obj.remoteParticipant._identifier.communicationUserId !== remoteParticipantObj.remoteParticipant._identifier.communicationUserId);

        this.remoteParticipantsState.unshift(remoteParticipantObj);
      } catch (e: any) {
        console.warn(`Failed to createView, reason=${e.message}, code=${e.code}`);
        let popupData : any = MeetingErrorType.bugParticipantCameraFeed;
        this.showErrorWarning(popupData)
      }
    };
    let participantCount = this.totalNumberOfParticipants.getValue();
    remoteVideoStream.on("isAvailableChanged", async () => {
      // Participant has switched video on.
      if (participantCount <= 8) {
        if (remoteVideoStream.isAvailable) {
          await renderVideo();
        }else{
          // handling remote screen share off dynamically here
          if(remoteVideoStream._mediaStreamType === "ScreenSharing" && (!remoteVideoStream.isAvailable && !remoteVideoStream._isAvailable)){
            this.isScreenShared = false;
            this.isRemoteScreenShared = false;
            // console.log('screen sharing is disbaled by remote user');
          }
        }
      }
    });
    // Participant has video on initially.
    if (remoteVideoStream.isAvailable) {
      if (participantCount <= 8) {
        await renderVideo();
      }
    }
  };

  displayLocalVideoStream = async (lvs:LocalVideoStream) => {
    let videoStreamRender : any = new VideoStreamRenderer(lvs);
    try {
      if(lvs.mediaStreamType == 'Video'){
        this.localVideoStreamRenderer = new VideoStreamRenderer(lvs);
        videoStreamRender = this.localVideoStreamRenderer;
      }else if(lvs.mediaStreamType === 'RawMedia'){
        this.localScreenShareStreamRenderer = new VideoStreamRenderer(lvs);
        videoStreamRender = this.localScreenShareStreamRenderer;
      }
      const view : any = await videoStreamRender?.createView();
      // console.log('localvideostream     : \n', view);

      switch (lvs.mediaStreamType) {
        case 'Video':
          var divElement = view.target;
          var videoElement = divElement.querySelector('video');
          videoElement.style.objectFit = 'cover';
          videoElement.classList.add('lvsVideo');

          var marqueSpan = document.createElement('span');
          var marqueMark = document.createElement('mark');
          divElement.appendChild(marqueSpan);
          var marqueeElement = document.createElement('marquee');

          marqueSpan.classList.add('lvsMarqueeContainer');
          marqueMark.textContent = this.localUserName;

          marqueeElement.classList.add('marqueeElement');
          marqueeElement.setAttribute('direction', 'left');
          marqueeElement.setAttribute('behavior', 'scroll');
          marqueeElement.appendChild(marqueMark);
          marqueSpan.appendChild(marqueeElement);

          this.localVideoOn = true;
          this.localVideo = divElement
          break;
        case 'RawMedia':
          var divElement = view.target;

          var videoElement = divElement.querySelector('video');

          videoElement.classList.add('lvsScreenShare');

          this.localScreenShareStream = divElement
          break;
        // No default case
      }
    } catch (error) {
      console.error(error);
      let popupData : any;
      switch (lvs.mediaStreamType) {
        case 'Video':
          popupData = MeetingErrorType.bugLocalVideoStream;
          this.showErrorWarning(popupData);
          break;
        case 'RawMedia':
          popupData = MeetingErrorType.bugLocalScreenShareStream;
           this.showErrorWarning(popupData);
          break;
        // No default case
      }
    }
  };

  // Create a local video stream for your camera device
  createLocalVideoStream = async () => {
    const camera = (await this.deviceManager.getCameras())[0];
    if (camera) {
      return new LocalVideoStream(camera);
    } else {
      console.error(`No camera device found on the system`);
      let popupData : any = MeetingErrorType.bugCameraNotFound;
      this.showErrorWarning(popupData);
      return;
    }
  };


  async joinChatButtonClick(): Promise<void> {
    try {
      this.chatClient = new ChatClient(this.endpointUrl, this.tokenCredential);
      this.chatThreadClient = this.chatClient.getChatThreadClient(
        this.videoForm.value.chatThreadId.trim()
      );
      // console.log(`Chat Thread client for threadId:${this.chatThreadClient}`);
      await this.chatClient.startRealtimeNotifications();
      this.chatMessages = [];
      //Read existing chats
      const messages = this.chatThreadClient.listMessages();
      for await (const message of messages) {
        this.chatMessages.push(message);
      }
      // subscribe to new notification
      this.chatClient.on('chatMessageReceived', (message: any) => {
        // console.log('Notification chatMessageReceived!');
        this.chatMessages.push(message);
        this.chatMessageCounter.push(message);
      });
    } catch (error) {
      console.error(error);
      this.rest.logUserLeftAndReloadScreen(this.videoForm.value,this.meetingEventType.UserLeft,'User Left',false);
    }
  }

  // Start your local video stream.
  // This will send your local video stream to remote participants so they can view it.
  startVideoButtonClick = async () => {
    try {
      const localVideoStream = await this.createLocalVideoStream();
      await this.call.startVideo(localVideoStream);
      this.stopVideoButton = true;
      if(this.isVideoControlEnabled){
      this.startVideoButton = false;
    }
      this.showUserInitialLocal = false;
      this.rest.LogMeetingHistory(this.videoForm.value,this.meetingEventType.TurnOnCamera,'camera turned on',false);
      this.isLocalUserCameraTurnedOn = true;
    } catch (error) {
      console.error(error);
      this.stopVideoButton = false;
      if(this.isVideoControlEnabled){
        this.startVideoButton = true;
      }
      let popupData : any = MeetingErrorType.bugCameraNotFound;
      this.showErrorWarning(popupData);
      // error has been handled
    }
  };

  startScreenShareButtonClick = async () => {
    try{

    const displayMediaOptions = {
       video: { cursor: 'always', audio: false }
    };
    
    this.screenStream = await navigator.mediaDevices.getDisplayMedia(<any>displayMediaOptions);
    let localVideoStreamTemp = new LocalVideoStream(this.screenStream);
    await this.call.startScreenSharing(localVideoStreamTemp);


    this.stopScreenShareButton = true;

    this.startScreenShareButton=false;
    this.rest.LogMeetingHistory(this.videoForm.value,this.meetingEventType.ScreenshareStart,'Screen share started',false);
  } catch(err){
    console.log(err);
    this.stopScreenShareButton = false;
    this.startScreenShareButton=true;
    let popupData : any = MeetingErrorType.bugLocalScreenShareStream;
    this.showErrorWarning(popupData);
  }
  };


  stopScreenShareButtonClick = async () => {
    try {
      await this.call.stopScreenSharing();
      this.isLocalScreenShared = false;
      const tracks = this.screenStream.getTracks();
      tracks.forEach((track : any) => track.stop());

      this.startScreenShareButton=true;

      this.stopScreenShareButton = false;
      this.rest.LogMeetingHistory(this.videoForm.value,this.meetingEventType.ScreenshareEnd,'Screen share stopped',false);
      this.isScreenShared = false;
    } catch (error) {
      this.startScreenShareButton=false;
      this.stopScreenShareButton = true;
      let popupData : any = MeetingErrorType.bugStopScreenShareStream
      this.showErrorWarning(popupData)
    }
  };

  // Stop your local video stream.
  // This will stop your local video stream from being sent to remote participants.
  stopVideoButtonClick = async () => {
    try {
      await this.call.stopVideo(this.localVideoStreamUser);
      if(this.isVideoControlEnabled){
      this.startVideoButton = true;
      }
      this.localVideoOn = false

      this.stopVideoButton = false;
      this.showUserInitialLocal = true;
      this.rest.LogMeetingHistory(this.videoForm.value,this.meetingEventType.TurnOffCamera,'camera turned off',false);
      this.isLocalUserCameraTurnedOn = false;
    } catch (error) {
      if(this.isVideoControlEnabled){
        this.startVideoButton = false;
        }
      this.stopVideoButton = true;
      this.showUserInitialLocal = false;
      console.error(error);
      let popupData : any = MeetingErrorType.bugturnOffCamera
      this.showErrorWarning(popupData)
    }
  };

  sendChatMessage = async () => {
    try{
    let checkIfEmptyMessage : any =  this.videoForm.value.userChatTest;
    if(checkIfEmptyMessage.trim() !== ''){
    const sendMessageRequest = { content: this.videoForm.value.userChatTest };
    let sendMessageOptions = { senderDisplayName: this.localUserName };
    this.chatThreadClient = this.chatClient.getChatThreadClient(
      this.videoForm.value.chatThreadId.trim()
    );
    const sendChatMessageResult = this.chatThreadClient.sendMessage(
      sendMessageRequest,
      sendMessageOptions
    );
    sendChatMessageResult
      .then((responseObject: any) => {
        // console.log(responseObject.id);
        if (responseObject.id === undefined) {
          this.rest.LogMeetingHistory(this.videoForm.value,this.meetingEventType.ChatError,'Chat error',false);
          let popupData : any = MeetingErrorType.bugMessageNotSent;
          this.showErrorWarning(popupData)
        } else {
          this.rest.LogMeetingHistory(this.videoForm.value,this.meetingEventType.MessageSent,'Message sent',false);
          this.scrollToBottom();
          this.scrollToBottomResponsive();
        }
      })
      .catch((error: any) => {
        let popupData : any = MeetingErrorType.bugMessageNotSent;
        this.showErrorWarning(popupData)
        console.error(error);
        this.rest.LogMeetingHistory(this.videoForm.value,this.meetingEventType.ChatError,'Chat error',false);
      });

    const messageId = sendChatMessageResult.id;
    // console.log(`Message sent!, message id:${messageId}`);

    this.videoForm.controls['userChatTest'].reset();
  }else{
    return;
  }
  }catch (error){
    console.error(error);
    let popupData : any = MeetingErrorType.bugMessageNotSent;
    this.showErrorWarning(popupData);
  }
  };

  removeLocalVideoStream = async (lvs : any) => {
    try {
      lvs.dispose();
    } catch (error) {
      console.error(error);
      let popupData : any
       switch (lvs.mediaStreamType) {
        case 'Video':
          popupData = MeetingErrorType.bugVideoFeedOff;
           this.showErrorWarning(popupData);
          break;
        case 'RawMedia':
          popupData = MeetingErrorType.screenShareOff;
           this.showErrorWarning(popupData);
          break;
        // No default case
      }
    }
  };

  leaveCallConfirmationPopup(){
    const dialogRef = this.dialog.open(AlertComponent, {
      width: '35vw',
      data: {
             data:'Do you want to leave the meeting?',
             type:'LeaveCall'
            }
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if(result){
        this.hangUpCallButtonClick();
      }else{

      }
    });
  }

  // End the current call
  async hangUpCallButtonClick() {
    try{
    // end the current call
    if(this.isLocalUserCameraTurnedOn){
      this.stopVideoButtonClick();
    }
    if(this.isLocalUserMicTurnedOn){
      this.muteAudioButtonClick();
    }
    await this.call.hangUp();
    this.teamsCallAgent.dispose();
    this.startScreenShareButton=false;
    this.startVideoButton = false;
    this.muteButton= false;
    this.initializeCallAgentButton= true;
    if(this.isEndMeetingButtonClicked){
      this.router.navigate(['/call-ended',callEndedType.meetingEnded.callId]);
    }else{
      this.rest.LogMeetingHistory(this.videoForm.value,this.meetingEventType.UserLeft,'User Left',false);
      this.router.navigate(['/call-ended',callEndedType.UserLeftTheCall.callId]);
    }
  }catch(err){
    this.startScreenShareButton=true;
    this.startVideoButton = true;
    this.muteButton= true;
    let popupData : any = MeetingErrorType.bugLeavingMeeting;
    // this.showErrorWarning(popupData);
    this.rest.logUserLeftAndReloadScreen(this.videoForm.value,this.meetingEventType.UserLeft,'User Left',false);
    console.error(err);
  }
  }


  muteAudioButtonClick() {
    try{
    if (this.call && this.call.isMuted === false) {
      this.call.mute();
      // console.log('Call muted');

      this.muteButton= false;

      this.unMuteButton= true;
      // Update UI to reflect the mute status
      this.rest.LogMeetingHistory(this.videoForm.value,this.meetingEventType.Mute,'audio turned off',false);
      this.isLocalUserMicTurnedOn = false;
    }
  }
    catch(err){
      console.log(err);
      this.muteButton= true;
      this.unMuteButton= false;
      let popupData : any = MeetingErrorType.bugturnOffMicroPhone;
      this.showErrorWarning(popupData)
    }
  }

  unMuteAudioButtonClick() {
    try{
    if (this.call && this.call.isMuted === true) {
      this.call.unmute();
      // console.log('Call unmuted');
      if(this.isAudioControlEnabled){

      this.muteButton= true;
      }

      this.unMuteButton= false;
      // Update UI to reflect the unmute status
      this.rest.LogMeetingHistory(this.videoForm.value,this.meetingEventType.Unmute,'audio turned on',false);
    }
    this.isLocalUserMicTurnedOn = true;
  }catch(err){
    if(this.isAudioControlEnabled){
      this.muteButton= false;
      }
      this.unMuteButton= true;
    console.log(err)
    let popupData : any = MeetingErrorType.bugturnOnMicroPhone;
    this.showErrorWarning(popupData);
  }
  }

  showMessageBoxMethod() {
    this.showMessageBox = true;
    if (this.showMessageBox == true) {
      this.messageUserBox = true;
      this.showUserList = false;
    } else {
      this.messageUserBox = false;
    }
  }
  hideMessageBoxMethod() {
    this.showMessageBox = false;
    if (this.showMessageBox == false) {
      this.messageUserBox = false;
      this.showUserList = false;
    } else {
      this.messageUserBox = false;
    }
    this.chatMessageCounter = [];
  }
  showUserListBoxMethod() {
    this.showUserList = true;
    if (this.showUserList == true) {
      this.messageUserBox = true;
      this.showMessageBox = false;
    } else {
      this.messageUserBox = false;
    }
  }
  HideUserListBoxMethod() {
    this.showUserList = false;
    if (this.showUserList == false) {
      this.messageUserBox = false;
      this.showMessageBox = false;
    } else {
      this.messageUserBox = false;
    }
  }

  showHideMessageBoxRes() {
    this.higherScreenRes = !this.higherScreenRes;
    this.chatMessageCounter = [];
  }
  showHideMessageBoxUserRes() {
    this.higherScreenResUser = !this.higherScreenResUser;
  }

  // ngOnDestroy() {
    // this.hangUpCallButtonClick();
  // }

  removeElementById(id: any) {
    var element: any = document.getElementById(id);
    if (element) {
      element.parentNode.removeChild(element);
    }
  }

  getFullId(baseId : any) {
    let fullId : any;
    if (document.getElementById('userLogo-' + baseId)) {
      fullId = 'userLogo-' + baseId;
    }
    else if (document.getElementById('remoteParticipantID-' + baseId)) {
      fullId = 'remoteParticipantID-' + baseId;
    }
    return fullId;
  }

  updateUserSpeakerState(){
    this.call.remoteParticipants.forEach((remoteParticipant: any) => {
      if (remoteParticipant.isSpeaking) {
        let selectedIdType:any = this.getFullId(remoteParticipant._identifier.communicationUserId);
        var existingUserLogo = document.getElementById(selectedIdType);
        if (existingUserLogo) {
          
        }
        // console.log(remoteParticipant._identifier.communicationUserId ,': Participant is speaking : ',remoteParticipant.isSpeaking);
      } else {
        let selectedIdType:any = this.getFullId(remoteParticipant._identifier.communicationUserId);
        var existingUserLogo = document.getElementById(selectedIdType);
        if (existingUserLogo) {
          
        }
        // console.log(remoteParticipant._identifier.communicationUserId ,': Participant is not speaking : ',remoteParticipant.isSpeaking);
      }
    });

    setTimeout(() => {
    this.updateUserSpeakerState();
    }, 1000);

  }


  sendFileInChat(event: any) {
    if (event.target.files.length > 0) {
      this.isFileUploading = true;
      this.selectedFile = <File>event.target.files[0];
      let formData: FormData = new FormData();
      formData.append("attachment",this.selectedFile );
      formData.append("groupCallID", this.videoForm.value.groupId);
      formData.append("userMeetingID", this.videoForm.value.userId);

        this.rest.acsMFEPostData(formData,ApiUrls.UploadAttachmentinChat,null,'LoginUrl').subscribe((data) => {
        if(data.rcode == 200){
          this.isFileUploading = false;
          event.target.value = '';
          this.scrollToBottom();
          this.scrollToBottomResponsive();
        }
      },
      (err) => {}
      );
    }
   }
getClassBasedOnUserCount(noOfUsers: any): any {
  const classMap : any = {
      1: 'remoteParticipant_MaxOne',
      2: 'remoteParticipant_MaxTwo',
      3: 'remoteParticipant_MaxThree',
      6: 'remoteParticipant_MaxSix',
      9: 'remoteParticipant_MaxNine',
      10: 'remoteParticipant_GreaterThanNine'
  };

  let selectedClass = '';
  if (noOfUsers >= 10) {
      selectedClass = classMap[10];
  } else {
      for (let key of Object.keys(classMap).map(Number).sort((a, b) => a - b)) {
          if (noOfUsers <= key) {
              selectedClass = classMap[key];
              break;
          }
      }
  }

  return {[selectedClass]: true};
}

  scrollToBottom(){
    setTimeout(() => {
      try {
        this.chatContainer.nativeElement.scrollTop = this.chatContainer.nativeElement.scrollTop +1000;
        this.chatContainer.nativeElement.scrollTop = this.chatContainer.nativeElement.scrollHeight;
      } catch (err) {}
    }, 2000);
  }

  scrollToBottomResponsive(){
    setTimeout(() => {
      try {
        this.chatContainerMob.nativeElement.scrollTop = this.chatContainerMob.nativeElement.scrollHeight;
      } catch (err) {}
    }, 2000);
  }

  async muteParticularParticipant(selectedParticipant: any){
    try{
    await selectedParticipant.mute();
    }catch(err){
      let popupData : any = MeetingErrorType.bugMuteParticularParticipant;
      this.showErrorWarning(popupData);
      console.error(err);
    }
  }

  async muteAllParticipant(){
    try{
    await this.call.muteAllRemoteParticipants();
  }catch(err){
    let popupData : any = MeetingErrorType.bugMuteAllParticipant;
    this.showErrorWarning(popupData);
    console.error(err);
  }
  }

  endCallConfirmationPopup(remoteParticipantStateArr : any){
    const dialogRef = this.dialog.open(AlertComponent, {
      width: '35vw',
      data: {
             data:'Are you sure you want to End the meeting?',
             type:'LeaveCall'
            }
    });
    dialogRef.afterClosed().subscribe((result: any) => {
      if(result){
        this.endMeeting(remoteParticipantStateArr)
      }else{

      }
    });
  }

   endMeeting(remoteParticipantStateArr : any){
    try{
      if(this.isLocalUserCameraTurnedOn){
        this.stopVideoButtonClick();
      }
      if(this.isLocalUserMicTurnedOn){
        this.muteAudioButtonClick();
      }
    this.isEndMeetingButtonClicked = true;
    remoteParticipantStateArr.forEach(async (remoteParticipant : any) => {
      const userIdentifier = { communicationUserId: remoteParticipant.remoteParticipant._identifier.communicationUserId };
      await this.call.removeParticipant(userIdentifier);
    });
    this.teamsCallAgent.dispose();
    this.rest.LogMeetingHistory(this.videoForm.value,this.meetingEventType.MeetingEnded,'Meeting Ended',true);
    this.router.navigate(['/call-ended',callEndedType.meetingEnded.callId]);
  }catch(err){
    console.log(err);
    let popupData : any = MeetingErrorType.bugEndingMeeting;
    this.showErrorWarning(popupData);
  }
  }


  async checkAndRequestCameraPermission() {
    try {
      const cameraStatus = await navigator.permissions.query({ name: 'camera' as PermissionName });
      if (cameraStatus.state === 'granted') {
        this.isCameraPermitted = true;
      } else if (cameraStatus.state === 'prompt') {
        this.isCameraPermitted = false;
      }
      const micStatus = await navigator.permissions.query({ name: 'microphone' as PermissionName });
      if (micStatus.state === 'granted') {
        this.isMicroPhonePermitted = true;
      } else if (micStatus.state === 'prompt') {
        this.isMicroPhonePermitted = false;
      }
      if(this.isCameraPermitted && this.isMicroPhonePermitted){
        this.showVideoWindow = 'PreviewVideoScreen';
        this.getMeeting();
      }
      // If the state is 'denied', permission is not granted, and you might want to handle it differently.
    } catch (error) {
      console.error(error);
    }
  }

  showSnackbar(userLeftMessage : any) {
    this.userLeftMessageSnackBar = userLeftMessage;
    if (this.userLeftToast) {
      this.renderer.addClass(this.userLeftToast.nativeElement,'show');
      setTimeout(() => {
        this.renderer.removeClass(this.userLeftToast.nativeElement,'show');
      }, 3000);
    }
  }

  showErrorWarning(dialogData: { data: string, type: string, errId : string }) {
    const dialogRef = this.dialog.open(AlertComponent, {
      width: '35vw',
      data: dialogData
    });
  }

}
